/* External */
import {
  memo,
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { OrderedMap } from 'immutable';

/* components */
import Filter from './Filter';

/* utils */
import { noOp } from '../../utils/functions';
import { COMPONENTS } from '../../utils/focusKey';
import useOnLeftArrowPress from '../../hooks/useOnLeftArrowPress';
import { useOpenSidebar } from '../../providers/SidebarStateContext';

/* styles */
import './FilterList.scss';

function FilterList({
  filters,
  selectedFilterId,
  onFilterSelect,
}) {
  const goToSideBar = useOpenSidebar();
  const handleLeftArrowPress = useOnLeftArrowPress(goToSideBar);

  const handleFilterBecameFocused = useCallback((_, { filterId, index }) => {
    onFilterSelect(filterId, index);
  }, [onFilterSelect]);

  const handleFilterEnterPress = useCallback(({ filterId, index }) => {
    onFilterSelect(filterId, index);
  }, [onFilterSelect]);

  const filterComponents = useMemo(() => (
    filters?.valueSeq().map((filter, index) => (
      <Filter
        key={filter.id}
        index={index}
        focusKey={`${COMPONENTS.EPG_FILTER_LIST}${filter.id}`}
        filterId={filter.id}
        isSelected={filter.id === selectedFilterId}
        onBecameFocused={handleFilterBecameFocused}
        onEnterPress={handleFilterEnterPress}
        onArrowPress={handleLeftArrowPress}
      >
        {filter.name}
      </Filter>
    ))
  ), [
    filters,
    selectedFilterId,
    handleFilterBecameFocused,
    handleFilterEnterPress,
    handleLeftArrowPress,
  ]);

  return (
    <div className="dtv-html5-c-filter-list">
      {filterComponents}
    </div>
  );
}

FilterList.propTypes = {
  filters: PropTypes.instanceOf(OrderedMap),
  selectedFilterId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onFilterSelect: PropTypes.func,
};

FilterList.defaultProps = {
  filters: undefined,
  selectedFilterId: '',
  onFilterSelect: noOp,
};

export default memo(withFocusable()(memo(FilterList)));
